// I file condivisi dal menù «Condividi» di Android: li riceve il service worker (public/sw.js), li mette qui e
// rimanda alla pagina del preventivo; la pagina li legge e li scarta. Stesso database e stesso store del service worker:
// una sola voce (chiave «ultima»), con un identificativo: vale l'ultima condivisione.
// Un guasto di IndexedDB si dice (la promessa rifiuta): la pagina lo mostra come «Allegati non ricevuti». Una voce che
// non c'è non è un guasto: `null`.

const DB = "aef-condivisi";
const STORE = "file";
const CHIAVE = "ultima";

function apri(): Promise<IDBDatabase> {
  return new Promise((ok, no) => {
    try {
      const r = indexedDB.open(DB, 1);
      r.onupgradeneeded = () => r.result.createObjectStore(STORE);
      r.onsuccess = () => ok(r.result);
      r.onerror = () => no(r.error ?? new Error("IndexedDB"));
      r.onblocked = () => no(new Error("IndexedDB bloccato"));
    } catch (e) {
      no(e);
    }
  });
}

/** Una transazione sullo store: `fa` ne usa lo store e dà la richiesta il cui risultato è la risposta. */
async function transazione(modo: IDBTransactionMode, fa: (s: IDBObjectStore) => IDBRequest | undefined): Promise<unknown> {
  const db = await apri();
  return new Promise((ok, no) => {
    try {
      const tx = db.transaction(STORE, modo);
      const r = fa(tx.objectStore(STORE));
      tx.oncomplete = () => { db.close(); ok(r?.result); };
      tx.onerror = () => { db.close(); no(tx.error); };
      tx.onabort = () => { db.close(); no(tx.error ?? new Error("IndexedDB interrotto")); };
    } catch (e) {
      db.close();
      no(e);
    }
  });
}

interface Voce { nome: string; tipo: string; blob: Blob }

/** I file in attesa, ricostruiti dai blob, con l'identificativo della condivisione; `null` se non c'è nulla. */
export async function leggiCondivisi(): Promise<{ id: string; files: File[] } | null> {
  const v = await transazione("readonly", (s) => s.get(CHIAVE)) as { id?: string; files?: Voce[] } | undefined;
  const files = (v?.files ?? []).filter((f) => f.blob)
    .map((f) => new File([f.blob], f.nome, { type: f.tipo || f.blob.type }));
  return v?.id && files.length > 0 ? { id: v.id, files } : null;
}

/** Toglie la voce solo se è ancora quella di `id`: una condivisione arrivata nel frattempo resta. */
export async function scartaCondivisi(id: string): Promise<void> {
  await transazione("readwrite", (s) => {
    const g = s.get(CHIAVE);
    g.onsuccess = () => { if ((g.result as { id?: string } | undefined)?.id === id) s.delete(CHIAVE); };
    return undefined;
  });
}
